<spr-page-with-header class="h-full" styleClass="p-6 xl:px-28">
	<p-tabView
		[activeIndex]="activeTabIndex$ | async"
		(activeIndexChange)="onActiveIndexChange($event)"
		class="flex-auto overflow-hidden"
		styleClass="flex flex-col h-full space-y-3"
	>
		<p-tabPanel
			[header]="'presentation.app.page.settings.coach.general.header' | translate"
		>
			<ng-scrollbar
				class="absolute w-full h-full top-0 left-0"
				track="vertical"
				visibility="hover"
			>
				<spr-coach-settings-general></spr-coach-settings-general>
			</ng-scrollbar>
		</p-tabPanel>
		<p-tabPanel
			[header]="
				'presentation.app.page.settings.coach.biography.header' | translate
			"
		>
			<ng-scrollbar
				class="absolute w-full h-full top-0 left-0"
				track="vertical"
				visibility="hover"
			>
				<p-card>
					<spr-settings-biography></spr-settings-biography>
				</p-card>
			</ng-scrollbar>
		</p-tabPanel>
		<p-tabPanel
			[header]="'presentation.app.page.settings.coach.calendar.header' | translate"
		>
			<ng-scrollbar
				class="absolute w-full h-full top-0 left-0"
				track="all"
				visibility="hover"
			>
				<p-card>
					<spr-coach-settings-calendar></spr-coach-settings-calendar>
				</p-card>
			</ng-scrollbar>
		</p-tabPanel>
	</p-tabView>
</spr-page-with-header>
